module.exports = __webpack_public_path__ + "static/flag180-64e0c27caaab728dafe4fc1e184e3a39.png";